module.exports = __webpack_public_path__ + "img/f4.375df35b.png";